import { render } from "./AddManualComp.vue?vue&type=template&id=3add2524&ts=true"
import script from "./AddManualComp.vue?vue&type=script&lang=ts"
export * from "./AddManualComp.vue?vue&type=script&lang=ts"

import exportComponent from "C:\\TeamCityBuildAgent\\work\\623dcfb411009e26\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__